module.exports = __webpack_public_path__ + "img/accessory_item_12.a4ef1d44.svg";